module.exports = __webpack_public_path__ + "static/media/apricot.19a0f744.png";